export default __webpack_public_path__ + "static/media/kebumen.a13b87c1.png";